import React, { FC } from 'react';
import { Form, Input } from 'antd';
import { useField, UseFieldConfig } from 'react-final-form';

interface IProps {
  name: string;
  label: string;
  placeholder?: string;
  useFieldConfig?: UseFieldConfig<string>;
}

const FormAntInput: FC<IProps> = ({ name, label, placeholder, useFieldConfig }) => {
  const {
    input,
    meta: { touched, error }
  } = useField(name, useFieldConfig);

  return (
    <Form.Item
      label={label}
      validateStatus={touched && error ? 'error' : undefined}
      help={touched && error ? error : undefined}
    >
      <Input
        value={input.value}
        onChange={event => input.onChange(event.target.value)}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};

export default FormAntInput;
